module.exports = __webpack_public_path__ + "static/img/android1.1.d5c6e548.jpg";